import { Money } from '@principle-theorem/accounting';
import {
  BILLING_METERS,
  BillingMeterId,
  BillingMeterPriceLookupId,
  IBaseSMSIntegrationData,
  IBillingMeterOption,
} from '@principle-theorem/principle-core/interfaces';
import { Region } from '@principle-theorem/shared';

export class BillingMeter {
  static findByLookupId(
    lookupId: BillingMeterPriceLookupId
  ): IBillingMeterOption {
    return BILLING_METERS[lookupId];
  }

  static resolveCostByLookupId(lookupId: BillingMeterPriceLookupId): number {
    const cost = BILLING_METERS[lookupId].costInCents;

    if (!cost) {
      return 0;
    }

    return Money.fromCents(cost);
  }

  static filterByMeterId(
    meterId: BillingMeterId,
    region: Region
  ): IBillingMeterOption[] {
    return Object.values(BILLING_METERS).filter(
      (option) => option.region === region && option.meterId === meterId
    );
  }

  static getDefaultBillingMeters(region: Region): IBaseSMSIntegrationData {
    const meters = Object.values(BILLING_METERS).filter(
      (option) => option.region === region && option.isDefault
    );

    const inbound = meters.find(
      (meter) => meter.meterId === BillingMeterId.SMSInboundSegments
    );
    const outbound = meters.find(
      (meter) => meter.meterId === BillingMeterId.SMSOutboundSegments
    );
    const marketing = meters.find(
      (meter) => meter.meterId === BillingMeterId.SMSMarketingSegments
    );

    return {
      inboundPriceId: inbound?.priceLookupId,
      outboundPriceId: outbound?.priceLookupId,
      marketingPriceId: marketing?.priceLookupId,
    };
  }
}
